module.exports = __webpack_public_path__ + "img/@sns_tw.efcca863.svg";